import React from "react";
import popup from "../../assets/images/modal-icon-api-error.svg";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import "./InvalidTokenPage.scss";

interface IProps {
}

const InvalidTokenPage = (props: IProps) => {
  const pasajLink = 'tcellhesabim://passagehome';
  return (
    <div id="invalid-token-page" className="page">
      <div className="page-content">
        <img className="popup-icon" src={popup} alt="popup"/>
        <FirebaseKey className="title" firebaseKey={FirebaseService.invalid_token_title}/>
        <FirebaseKey className="text" firebaseKey={FirebaseService.invalid_token_text}/>
        <a href={pasajLink} className="d-flex" rel="noreferrer">
          <span className="back-button">PASAJ'A DÖN</span>
        </a>
      </div>
    </div>
  );
}

export default InvalidTokenPage;
